var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { staticStyle: { "min-height": "280px !important" } },
    [
      _c(
        "v-container",
        [
          _c(
            "v-row",
            { staticClass: "mb-0 mt-n2" },
            [
              _c(
                "v-col",
                { staticClass: "d-flex flex-row pl-7", attrs: { cols: "3" } },
                [
                  _c("img", {
                    staticClass: "mr-2",
                    attrs: {
                      src: require("@/assets/IconE.svg"),
                      width: "30px",
                      height: "30px"
                    }
                  })
                ]
              ),
              _c(
                "v-col",
                { staticClass: "d-flex flex-row ml-n5", attrs: { cols: "8" } },
                [_c("h3", [_vm._v(" " + _vm._s(_vm.equipment.name) + " ")])]
              ),
              _c(
                "v-col",
                { attrs: { cols: "1" } },
                [
                  _vm.deletePrivilege || _vm.updatePrivilege
                    ? _c(
                        "v-menu",
                        {
                          attrs: {
                            "offset-y": "",
                            "offset-x": "",
                            left: "",
                            "offset-overflow": "",
                            "close-on-content-click": false
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  return [
                                    _c(
                                      "v-btn",
                                      _vm._g({ attrs: { icon: "" } }, on),
                                      [
                                        _c(
                                          "v-icon",
                                          {
                                            staticStyle: {
                                              transform: "scale(1.2)"
                                            }
                                          },
                                          [_vm._v("mdi-dots-vertical")]
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            2262209999
                          ),
                          model: {
                            value: _vm.menu,
                            callback: function($$v) {
                              _vm.menu = $$v
                            },
                            expression: "menu"
                          }
                        },
                        [
                          _c(
                            "v-list",
                            _vm._l(_vm.options, function(option, index) {
                              return _c(
                                "v-list-item",
                                {
                                  key: index,
                                  on: {
                                    click: function($event) {
                                      return _vm.executeOptionFunction(
                                        option.title
                                      )
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      staticClass: "ml-3",
                                      staticStyle: { transform: "scale(1.2)" },
                                      attrs: { medium: "" }
                                    },
                                    [_vm._v(_vm._s(option.icon))]
                                  ),
                                  _c(
                                    "v-list-item-title",
                                    { staticClass: "ml-6" },
                                    [_vm._v(_vm._s(option.title))]
                                  )
                                ],
                                1
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-row",
            { staticClass: "mt-n5 mb-0" },
            [
              _c(
                "v-col",
                {
                  attrs: {
                    cols:
                      _vm.equipment.dataCenters.length === 2
                        ? "12"
                        : _vm.tabSize
                  }
                },
                [
                  _c(
                    "v-tabs",
                    {
                      attrs: { "background-color": "transparent", grow: "" },
                      model: {
                        value: _vm.datacenterTab,
                        callback: function($$v) {
                          _vm.datacenterTab = $$v
                        },
                        expression: "datacenterTab"
                      }
                    },
                    _vm._l(_vm.equipment.dataCenters, function(
                      dataCenter,
                      index
                    ) {
                      return _c("v-tab", { key: index }, [
                        _vm._v(" " + _vm._s(dataCenter.name) + " ")
                      ])
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-row",
            { staticClass: "mt-n5" },
            [
              _c(
                "v-col",
                { attrs: { cols: "12" } },
                [
                  _c(
                    "v-tabs-items",
                    {
                      model: {
                        value: _vm.datacenterTab,
                        callback: function($$v) {
                          _vm.datacenterTab = $$v
                        },
                        expression: "datacenterTab"
                      }
                    },
                    _vm._l(_vm.equipment.dataCenters, function(
                      dataCenter,
                      index
                    ) {
                      return _c(
                        "v-tab-item",
                        { key: "DC1" + index },
                        [
                          _c(
                            "v-card",
                            {
                              staticClass: "buildingsCard",
                              staticStyle: { overflow: "auto" },
                              attrs: { flat: "" }
                            },
                            [
                              _c(
                                "v-card-text",
                                { staticClass: "mt-n5 mb-n5 pb-0" },
                                [
                                  _c(
                                    "v-container",
                                    { staticClass: "mt-0 pt-0 mb-n7 pb-0" },
                                    [
                                      _c(
                                        "v-row",
                                        { staticClass: "mt-0" },
                                        _vm._l(
                                          dataCenter.buildingDataCenter,
                                          function(buildingDataCenter, index) {
                                            return _c(
                                              "v-col",
                                              {
                                                key: "BDC" + index,
                                                staticClass: "mt-0 subtitle-1",
                                                staticStyle: { color: "black" },
                                                attrs: {
                                                  cols:
                                                    dataCenter
                                                      .buildingDataCenter
                                                      .length === 1
                                                      ? "12"
                                                      : "6",
                                                  color: "black"
                                                }
                                              },
                                              [
                                                _c(
                                                  "v-icon",
                                                  { attrs: { color: "blue" } },
                                                  [_vm._v("mdi-city-variant")]
                                                ),
                                                _vm._v(
                                                  _vm._s(
                                                    buildingDataCenter.building
                                                      .name
                                                  ) + " "
                                                )
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-row",
            { staticClass: "mt-n6" },
            [
              _c(
                "v-col",
                { attrs: { cols: "12" } },
                [_c("v-divider", { attrs: { color: "black" } })],
                1
              )
            ],
            1
          ),
          _c(
            "v-row",
            { staticClass: "mt-n2" },
            [
              _c(
                "v-col",
                { attrs: { cols: "12" } },
                [
                  _c(
                    "v-slide-group",
                    {
                      staticStyle: { "border-radius": "10% !important" },
                      attrs: { "show-arrows": "", "center-active": "" }
                    },
                    _vm._l(_vm.equipment.parameters, function(
                      parameter,
                      index
                    ) {
                      return _c("v-slide-item", {
                        key: "P" + index,
                        staticStyle: { "border-radius": "10% !important" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(ref) {
                                var active = ref.active
                                var toggle = ref.toggle
                                return [
                                  _c(
                                    "v-card",
                                    {
                                      staticClass: "mx-2 pb-n9 parameter-card",
                                      staticStyle: {
                                        "border-radius": "10% !important"
                                      },
                                      attrs: {
                                        width: "125",
                                        dark: "",
                                        ripple: false
                                      },
                                      on: { click: toggle }
                                    },
                                    [
                                      _c(
                                        "v-row",
                                        {
                                          staticClass: "mb-n3",
                                          staticStyle: {
                                            "border-radius": "10% !important"
                                          },
                                          attrs: { justify: "center" }
                                        },
                                        [
                                          _c(
                                            "v-col",
                                            {
                                              staticClass:
                                                "d-flex justify-center overline mb-n3 mx-n3",
                                              staticStyle: {
                                                "text-align": "center"
                                              },
                                              attrs: { cols: "12" }
                                            },
                                            [
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(parameter.name) + " "
                                                )
                                              ])
                                            ]
                                          )
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-row",
                                        {
                                          staticClass:
                                            "mt-n3 mb-n3 d-flex justify-center",
                                          attrs: { justify: "center" }
                                        },
                                        [
                                          _c(
                                            "v-col",
                                            {
                                              staticClass:
                                                "d-flex justify-center mt-0 pb-n3",
                                              staticStyle: {
                                                "text-align": "center",
                                                "font-size": "25px"
                                              },
                                              attrs: { cols: "12" }
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    parameter.measureUnit
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      })
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }